export const CURRENCY = '$';

export type Plan = {
  id: 'monthly' | 'yearly' | 'lifetime';
  name: string;
  price: string;
  period: string;
  calls: string;
  tagline: string;
  cta: string;
  featured?: boolean;
  badge?: string;
};

export const PLANS: Plan[] = [
  {
    id: 'monthly',
    name: 'Monthly',
    price: '3.49',
    period: '/mo',
    calls: '3,000',
    tagline: 'Pay as you go',
    cta: 'Get started',
  },
  {
    id: 'yearly',
    name: 'Yearly',
    price: '39.99',
    period: '/yr',
    calls: '3,000',
    tagline: 'Best for production',
    cta: 'Get annual access',
    featured: true,
    badge: 'Most popular',
  },
  {
    id: 'lifetime',
    name: 'Lifetime',
    price: '199.99',
    period: 'once',
    calls: '5,000',
    tagline: 'Never pay again',
    cta: 'Join for life',
  },
];

export const PLAN_INCLUDES = [
  'Movies, series & episode metadata',
  'Multilingual data sets',
  'Partial requests & lookup by source',
  'Commercial-use license',
  'iOS, Android, desktop & web',
];
